import moment from 'moment';
import React from 'react';
import { useMyUserId } from '../../../../../data/hooks/sessionHooks';
import resolvePath from '../../../../../misc/resolvePath';
import AttachmentsList from '../../../../elements/AttachmentsList/AttachmentsList';
import HighlightSpecialContents from '../../../../elements/HighlightSpecialContents';
import ListItem, { ListItemContent, ListItemImage } from '../../../../elements/ListItem';
import styles from './Answer.module.scss';
import AppointmentButton from './AppointmentButton';
import ChatButton from './ChatButton';
import EditAnswerButton from './EditAnswerButton';
import TimeFromNow from '../../../../elements/TimeFromNow/TimeFromNow';

const Answer = (props) => {
    const { question, answer } = props,
        myUserId = useMyUserId();

    function handleAnswererAvatarClicked() {
        let answererId = answer.answerer_id;
        if (!answer.anonymous && answererId) {
            let path2open = resolvePath(app.history.location.pathname, './participants/' + answererId + '/-');
            app.history.push(path2open);
        }
    }

    function handleAnswerImageClicked(attachment) {
        app.history.push(resolvePath(app.history.location.pathname, 'attached', answer.id.toString(), attachment.id.toString()));
    }

    return (
        <ListItem>
            <ListItemImage src={answer.answerer.image_url} altSrc="img/no_avatar.png" onClick={handleAnswererAvatarClicked} size={50} round />
            <ListItemContent>
                <HighlightSpecialContents className={[styles.content, 'text', 'main'].join(' ')} tagName="p" emails="emails" urls="urls">
                    {answer.content}
                </HighlightSpecialContents>
                <AttachmentsList attachments={answer.attachments} size={85} srcSize={220} hscroll="hscroll" onImageClicked={(attachment) => handleAnswerImageClicked(attachment)} />
                <div className={['text', styles.name].join(' ')}>{answer.answerer.name || answer.answerer.first_name + ' ' + answer.answerer.last_name}</div>
                <div className="text">
                    <TimeFromNow>{answer.date_created}</TimeFromNow>
                </div>
                <div>
                    {myUserId == answer.answerer_id ? <EditAnswerButton {...props} /> : null}
                    {myUserId == question.asker_id && myUserId != answer.answerer_id ? (
                        <>
                            <AppointmentButton {...props} />
                            <ChatButton {...props} />
                        </>
                    ) : null}
                </div>
            </ListItemContent>
        </ListItem>
    );
};

export default Answer;
